import React from "react";
import logo from "assets/images/logo.png";

function WelcomeSection(props) {
  return (
    <div className="w-full">
      <div className="d-flex flex-column align-items-start justify-center gap-4">
        <h1 className="fw-semibold">ยินดีต้อนรับ</h1>
        <div>
          <img src={logo} alt="" className="max-w-96" />
        </div>
        <h2>สร้างรายได้อีกต่อกับตัวช่วยสุดเจ๋งให้กับคุณ</h2>
      </div>
    </div>
  );
}

export default WelcomeSection;
